import React from 'react';
import { AnyField } from '../fields';
import HiddenInput from './HiddenInput';

const HiddenFields = ({
  fields,
}: {
  fields: { [key: string]: AnyField };
}): JSX.Element => (
  <>
    {Object.values(fields)
      .filter(({ hidden }) => hidden)
      .map((field) => (
        <HiddenInput field={field} key={field.id} />
      ))}
  </>
);

export default HiddenFields;
